import { createModel } from '@rematch/core';
import { DepartmentItem, IResourceItem, ISessionInfo, RoleItem } from 'services/user-role/types';
import { getResourceListByRoleId, getUserSessionInfo } from 'services/user-role/user.service';
import { getLocalStorage, setLocalStorage, USER_ROLE } from 'utils/storage';

import { RootModel } from '..';


export interface IUserSessionInfo {
  userInfo: ISessionInfo;
  userCurrentRole?: RoleItem;
  departmentPathList?: DepartmentItem[];
  resourceList?: IResourceItem[]; // 菜单权限
}

export const userRole = createModel<RootModel>()({
  state: {} as IUserSessionInfo,
  reducers: {
    update(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
    updateUserCurrentRoleCache(state, payload: RoleItem) {
      let dealWithState = {
        ...state,
        userCurrentRole: payload,
      };
      return dealWithState;
    },
    updateResourceListCache(state, payload: IResourceItem[]) {
      let dealWithState = {
        ...state,
        resourceList: payload,
      };
      return dealWithState;
    },
  },

  effects: dispatch => ({
    async updateAsync() {
      const res = await getUserSessionInfo();
      let userCurrentRole = undefined;
      if (res?.result?.customRoleList && res?.result?.customRoleList.length > 0) {
        if (getLocalStorage(USER_ROLE)) {
          userCurrentRole = res?.result?.customRoleList.find(item => item.id === String(getLocalStorage(USER_ROLE)));
        }
        userCurrentRole = userCurrentRole || res?.result?.customRoleList[0];
      }
      setLocalStorage(USER_ROLE, userCurrentRole?.id || '');
      const resourceData = await getResourceListByRoleId(userCurrentRole?.id as string);
      const menus_list = (resourceData?.result || []).filter(item => Boolean(item.selected));
      const [departmentPathList] = res?.result?.departmentPathList || [];
      dispatch.userRole.update({
        userInfo: res.result,
        userCurrentRole,
        resourceList: menus_list,
        departmentPathList: departmentPathList,
      });
    },
  }),
});
